import React, {Component} from 'react';

class AutoCompleteField extends Component {
  autoCompleteOptionType = ['address'];

  constructor(props) {
    super(props);

    this.state = {
      address: []
    }
  }

  handlePlacesScriptLoad() {
    // Declare Options For Autocomplete 
    // const options = { types: ['(cities)'] };
    const options = { 
      // types: ['(cities)'],
      types: this.autoCompleteOptionType,
      // types: ['(regions)'],
      componentRestrictions: {country: 'us'}
    };
    
    // Initialize Google Autocomplete 
    this.autocomplete = new window.google.maps.places.Autocomplete(
                          this.props.innerRef.current,
                          options );
    // Avoid paying for data that you don't need by restricting the 
    // set of place fields that are returned to just the address
    // components and formatted address
    this.autocomplete.setFields(['address_components',   
                                'formatted_address']);
    // Fire Event when a suggested name is selected
    this.autocomplete.addListener('place_changed',
                                  this.handlePlaceSelect); 
  }

  handlePlaceSelect = () => {

    // Extract City From Address Object
    const addressObject = this.autocomplete.getPlace();
    const address = addressObject.address_components;
    address.push({formatted_address:addressObject.formatted_address});

    // Check if address is valid
    if (address) {
      // Set State
console.log('address', address);
      this.setState({address});
      this.props.handlePlaceSelect(address);
    }
  }

  componentDidMount() {
    this.handlePlacesScriptLoad();
  }

  render() {
    const {
      type,
      className,
      name,
      placeholder,
      onChange,
      value,
      innerRef,
      required
    } = this.props;

    return(
      <input 
        type={type || 'text'}
        className={className}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        ref={innerRef}
        required={required}
        />
    );
  }
}

export default AutoCompleteField;
// export default React.forwardRef((props, ref)=> <AutoCompleteField innerRef={ref} {...props} />)